export function SideClose() {
  return (
    <label
      htmlFor="side-toggle"
      className="btn d-lg-none side-toggle btn-close"
      aria-label="Close details panel"
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.target.click();
        }
      }}
    ></label>
  );
}
